import React from 'react';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import TranslatedText from '../../../../components/atoms/translated_text';
import ApplicantActions from 'redux/reducers/applicant_list_reducer/actions';
import { Translations } from '../../configuration';
import { ModalIDs } from '../../../../redux/reducers/gl_modal_reducer/types';
import ModalActions from '../../../../redux/reducers/gl_modal_reducer/actions';
import { Roles } from 'config';

interface IProps {
  rowIndex: number;
  applicant_id: number;
  verified: boolean;
  ROLE: Roles;
  vatNumber: string;
}

export default function ActionsBlock(props: IProps) {
  const dispatch = useDispatch();

  const resenderVerification = () => {
    dispatch(
      ApplicantActions.resendVerificationLinkAction({
        applicant_id: props.applicant_id,
      })
    );
  };

  const createVatReturn = () => {
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_ADD_VAT_RETURN,
        params: {
          role: props.ROLE,
          inputVatNumber: props.vatNumber,
        },
      })
    );
  };

  return (
    <div>
      {!props.verified && (
        <Button
          variant="outlined"
          color={'primary'}
          onClick={resenderVerification}
        >
          <TranslatedText textMap={Translations.resend_verification_link} />
        </Button>
      )}
      {props.ROLE === Roles.Agent && (
        <Button variant="outlined" color={'primary'} onClick={createVatReturn}>
          ADD VAT RETURN
        </Button>
      )}
    </div>
  );
}
